import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/utils/i18n'
import Vant from 'vant'

import './assets/font_3451719_3o1kpcbja5u/iconfont.css'
import 'vant/lib/index.css'

import 'normalize.css'
import '@/assets/scss/main.scss'
import Api from '@/utils/api'
import CookieApi from '@/utils/cookieApi'
import Common from '@/utils/common'

import Head from '@/components/Head.vue'
import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'
import Empty from '@/components/Empty.vue'

Vue.prototype.$Api = Api
Vue.prototype.$CookieApi = CookieApi
Vue.prototype.$Common = Common

Vue.component('Head', Head)
Vue.component('NavBar', NavBar)
Vue.component('Footer', Footer)
Vue.component('Empty', Empty)

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'development') {
    Vue.config.devtools = true
} else {
    Vue.config.devtools = false
}
Vue.use(Vant)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
